export class ReporteVisita {


    public idCompania: string;
    public idPunto: string;
    public idVisita: string;
    public idTarea: string;
    public nombrePunto: string; 
    public direccion: string;
    public totalPendientes: number;
    public totalAbortados: number;
    public totalVisitados: string;
    public fecha: Date;
    public longitud: string;
    public latitud: string;

    public fechaInicio: string;
    public fechaFinaliacion: string;


    public longitudEntrega: string;
    public latitudEntrega: string;

    public imagen: string;
    public nombreFirma: string;
    public fechaCertificacion: string;

    public estado: string;

    public numeroGuia: string;

    public motivo: string;

    public distancia: string;

    public alerta: string;
}
